import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=7f523fb7"
import script from "./wx.vue?vue&type=script&lang=js"
export * from "./wx.vue?vue&type=script&lang=js"
import style0 from "./wx.vue?vue&type=style&index=0&id=7f523fb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports